module.exports = __webpack_public_path__ + "static/img/list-img0 - 副本 (2).86db49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img0 - 副本 (2).png
// module id = on1w
// module chunks = 0